import { FC } from 'react';

import Button from 'components/atoms/Button';
import { PageHeaderContent } from 'types/contentful/Sections/PageHeaderContent';

interface Props {
  header: Omit<PageHeaderContent, 'id'>;
}

export const LevelThreeHero: FC<Props> = ({ header }) => (
  <div className="content-wrapper">
    <h1 className="h3 max-w-[840px]">{header.title}</h1>
    <div className="items-center mt-6 mb-16 laptop:flex laptop:items-center laptop:mx-auto tablet:mb-20 laptop:mb-28">
      {header.ingress && (
        <p className="ingress max-w-[744px] mt-6">{header.ingress}</p>
      )}
      {header.cta && (
        <Button
          iconPosition="right"
          href={header.cta.href}
          className="inline-flex mt-8 laptop:mt-0 laptop:ml-16 laptop:flex-shrink-0"
        >
          {header.cta.text}
        </Button>
      )}
    </div>
  </div>
);
